import type React from 'react'
import {createContext, use, useMemo} from 'react'

export type AuthorSettings = {
  fontWeight: 'var(--base-text-weight-normal)' | 'var(--base-text-weight-medium)' | 'var(--base-text-weight-semibold)'
  fontColor: 'var(--fgColor-default)' | 'var(--fgColor-muted)'
  includeTooltip: boolean
  avatarSize: 16 | 20 | undefined
}

const defaultSettings: AuthorSettings = {
  fontWeight: 'var(--base-text-weight-semibold)' as const,
  fontColor: 'var(--fgColor-default)' as const,
  includeTooltip: false,
  avatarSize: undefined, // defaults to primer component default
}

const AuthorSettingsContext = createContext<AuthorSettings>(defaultSettings)

export function AuthorSettingsProvider({
  authorSettings,
  children,
}: React.PropsWithChildren<{authorSettings: Partial<AuthorSettings> | undefined}>) {
  const authorSettingsOrDefault = useMemo(() => ({...defaultSettings, ...authorSettings}), [authorSettings])
  return <AuthorSettingsContext value={authorSettingsOrDefault}>{children}</AuthorSettingsContext>
}

export function useAuthorSettings() {
  return use(AuthorSettingsContext) || defaultSettings
}
